<div class="row" style="padding-top: 100px;">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<div class="container" style="padding-right: 50px; max-width: 93.5%;">
  <div class="row" style="margin-right: 174px;">
    <div
      class="col-md-5 pull-right hidden-xs hidden-sm"
      style="float: left !important; margin-left: -10px;"
    >
      <div class="yCmsContentSlot login-right-content-slot">
        <div class="yCmsComponent login-right-content-component">
          <div class="banner__component simple-banner">
            <a style="display: block;">
              <img
                style="
                  width: 379px;
                  height: 529px;
                  top: -13.38px;
                  left: 7.4px;
                  margin-top: 49px;
                  border-radius: 20px;
                "
                title="login image"
                alt="login image"
                src="assets/img/syarat&ketentuan.png"
                width="20px"
                height="20px"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6" style="margin-top: 38px; margin-left: 15px;">
      <div
        class="yCmsContentSlot regist-left-content-slot js-regist-slot"
        style="margin-right: 10px; display: flex; flex-direction: column;"
      >
        <div
          class="yCmsComponent regist-left-content-component"
          style="order: 2;"
        >
          <div class="tnc-section">
            <div>
              <div>
                <div>
                  <h3
                    class="title-tnc"
                  >
                    Kebijakan Privasi
                  </h3>
                </div>
                <div
                class="row-syarat"
                >
                  <p
                  class="update-tnc"
                  >
                    Update Terakhir: 11 November 2021
                  </p>
                </div>
                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    PT Sukanda Djaya (“<b>Sukanda OneLink</b>”, “<b>Kami</b>”
                    atau “<b>Kita</b>”) berkomitmen untuk melindungi privasi
                    Anda. Kebijakan dan Privasi ini menjelaskan bagaimana
                    informasi pribadi dikumpulkan, digunakan, dan diinformasikan
                    oleh Kami. Kebijakan dan Privasi ini berlaku untuk Platform
                    Kami. Dengan mengakses atau menggunakan Layanan Kami,
                    menandakan bahwa Anda telah membaca, memahami, dan
                    menyetujui penyimpanan, penggunaan, serta pengungkapan
                    informasi pribadi Anda.
                  </p>
                </div>
                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Definisi dan Istilah
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Untuk membantu menjelaskan beberapa hal sejelas mungkin
                    dalam Kebijakan dan Privasi, dan secara saksama
                    didefinisikan sebagai:
                  </p>
                </div>
                <div class="row-syarat">
                  <ol
                   class="content-tnc"
                  >
                    <li>
                      Cookie: sejumlah data yang dihasilkan oleh situs web dan
                      disimpan oleh browser web Anda. Ini digunakan untuk
                      mengidentifikasi browser Anda, menyediakan analisis, dan
                      informasi seperti preferensi bahasa atau aktivitas login
                      Anda.
                    </li>
                    <li>
                      Perusahaan: ketika kebijakan ini menyebutkan “PT Sukanda
                      Djaya”, "perusahaan", "Kami", “Kita” atau "milik Kami",
                      itu mengacu pada Sukanda OneLink yang bertanggung jawab
                      atas informasi Anda berdasarkan Kebijakan dan Privasi ini.
                    </li>
                    <li>
                      Negara: di mana pemilik Sukanda OneLink berada di
                      Indonesia.
                    </li>
                    <li>
                      Pelanggan: mengacu pada perusahaan, organisasi, atau orang
                      yang mendaftar untuk menggunakan layanan Sukanda OneLink.
                    </li>
                    <li>
                      Perangkat: perangkat yang terhubung ke internet seperti
                      ponsel, tablet, komputer, atau perangkat lain yang dapat
                      digunakan untuk mengunjungi dan menggunakan Layanan
                      Sukanda OneLink.
                    </li>
                    <li>
                      Alamat IP: setiap perangkat yang terhubung ke internet
                      diberi nomor yang dikenal sebagai alamat protokol internet
                      (IP). Alamat IP sering kali dapat digunakan untuk
                      mengidentifikasi lokasi perangkat terhubung ke Internet.
                    </li>
                    <li>
                      Personil: merujuk pada individu yang berkontribusi secara
                      tetap di Sukanda OneLink atau terikat kontrak untuk
                      melakukan Layanan.
                    </li>
                    <li>
                      Data Pribadi: informasi apa pun yang secara langsung,
                      tidak langsung, atau terkait dengan informasi lain,
                      termasuk nomor identifikasi pribadi.
                    </li>
                    <li>
                      Layanan: mengacu pada layanan yang disediakan oleh Kami
                      seperti yang dijelaskan dalam ketentuan ini.
                    </li>
                    <li>
                      Layanan pihak ketiga: mengacu pada pengiklan, sponsor,
                      promosi, mitra pemasaran, dan orang lain yang menyediakan
                      konten mencakup produk dan layanan Kami.
                    </li>
                    <li>
                      Website: Sukanda OneLink dapat diakses melalui URL ini:
                      <a href="https://www.sukandaonelink.com/">www.sukandaonelink.com</a>
                    </li>
                    <li>
                      Anda: individu atau perusahaan yang terdaftar di Sukanda
                      OneLink untuk menggunakan Layanan ini.
                    </li>
                  </ol>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Informasi yang kami kumpulkan
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami mengumpulkan informasi ketika Anda mengunjungi Platform
                    Kami mencakup pendaftaran, pemesanan, maupun mengisi
                    formulir survey.
                  </p>
                </div>

                <div class="row" style="width: 800px;">
                  <ul
                   class="content-tnc"
                  >
                    <li>
                      Nama
                    </li>
                    <li>
                      Alamat email
                    </li>
                    <li>Nomor telepon</li>
                    <li>
                      Kata sandi
                    </li>
                  </ul>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Informasi yang dikumpulkan dari pelanggan
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Sukanda OneLink akan mengumpulkan informasi pribadi yang
                    Anda kirimkan. Kami juga dapat menerima informasi pribadi
                    Anda dari pihak ketiga seperti yang dijelaskan di atas.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami menggunakan informasi yang Kami kumpulkan dan dapat
                    digunakan dengan salah satu cara berikut:
                  </p>
                </div>

                <div class="row" style="width: 800px;">
                  <ul
                   class="content-tnc"
                  >
                    <li>
                      Mempersonalisasi pengalaman Anda
                    </li>
                    <li>
                      Meningkatkan Platform Kami
                    </li>
                    <li>
                      Memproses transaksi
                    </li>
                    <li>
                      Mengelola konten, promosi, survey, atau fitur Platform
                      lainnya
                    </li>
                    <li>
                      Mengirim email secara berkala
                    </li>
                  </ul>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Kami menggunakan alamat email Anda
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Anda setuju untuk menerima email dari Kami dengan
                    mengirimkan alamat email di Platform Sukanda OneLink.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Kami menyimpan informasi Anda
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami menyimpan informasi Anda hanya selama Kami
                    membutuhkannya untuk peningkatan Layanan Sukanda OneLink dan
                    memenuhi tujuan yang dijelaskan dalam kebijakan ini.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Kami melindungi informasi Anda
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami menggunakan server yang aman untuk menjaga keamanan
                    informasi pribadi Anda. Namun, Kami tidak dapat memastikan
                    atau menjamin keamanan mutlak dari setiap informasi yang
                    Anda kirimkan ke Sukanda OneLink tidak dapat diakses,
                    diinformasikan, dirubah, atau pelanggaran teknis lainnya.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Kami mengamankan informasi Anda
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami melakukan tindakan pencegahan untuk melindungi keamanan
                    informasi Anda. Kami memiliki prosedur fisik, elektronik,
                    dan manajerial untuk mencegah akses yang tidak sah, menjaga
                    keamanan data, dan menggunakan informasi Anda dengan benar.
                    Meskipun Kami menggunakan upaya untuk melindungi informasi
                    pribadi Anda, Kami tidak dapat menjamin keamanan mutlak
                    karena tidak bisa dibuktikan melalui sistem enkripsi.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Anda dapat memperbaiki atau memperbarui akun Anda
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Anda berhak meminta pembaruan atau memperbaiki informasi
                    pada layanan Sukanda OneLink sesuai dengan kebijakan Kami.
                    Anda dapat menghubungi Kami untuk (1) memperbarui atau
                    memperbaiki informasi pribadi, (2) mengubah preferensi
                    komunikasi dan informasi pribadi, atau (3) menghapus
                    informasi pribadi dengan membatalkan akun Anda. Untuk
                    melindungi Privasi dan keamanan Anda, Kami dapat mengambil
                    langkah-langkah untuk memverifikasi identitas sebelum
                    memberi akses profil untuk Anda. Anda bertanggung jawab
                    untuk menjaga kerahasiaan kata sandi dan informasi akun
                    setiap saat.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Afiliasi
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami dapat memberitahukan informasi Anda kepada afiliasi
                    Kami yang secara langsung atau tidak langsung mengendalikan,
                    dikendalikan, atau berada di bawah kendali yang sama dengan
                    Grup Diamond.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Peraturan Pemerintah
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kebijakan dan Privasi ini diatur oleh hukum Indonesia.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Persetujuan Anda
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Anda dengan ini menyetujui Kebijakan dan Privasi Kami dengan
                    transparansi penuh, saat Anda menggunakan layanan Sukanda
                    OneLink yang mencakup pendaftaran akun atau melakukan
                    pemesanan.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Rincian Pembayaran
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami berkomitmen bahwa informasi rahasia ini akan disimpan
                    dengan cara yang paling aman sehubungan dengan rincian
                    pemrosesan pembayaran yang Anda berikan kepada Kami.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Perubahan Kebijakan dan Privasi Kami
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Kami akan memberi tahu dan memberi Anda kesempatan untuk
                    memeriksa sebelum Kami membuat perubahan pada Kebijakan dan
                    Privasi. Anda akan terikat oleh Kebijakan dan Privasi yang
                    diperbarui jika Anda terus menggunakan layanan Kami. Anda
                    dapat menghapus akun jika tidak menyetujui Kebijakan dan
                    Privasi apa pun yang diperbarui.
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                   class="title-content"
                  >
                    Hubungi Kami
                  </p>
                </div>

                <div class="row-syarat">
                  <p
                    class="content-tnc"
                  >
                    Jangan ragu untuk menghubungi Kami jika Anda memiliki
                    pertanyaan.
                  </p>
                </div>

                <div class="row-syarat">
                  <ul
                   class="content-tnc"
                  >
                    <li>
                      Nomor Telepon : whatsapp 081285015025 (text only) 1500982
                      (call)
                    </li>
                    <li>
                      Email : customer.support@sukandaonelink.com
                    </li>
                    <li>
                      Website : https://open.sukandaonelink.com/contact-us
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div
            class="yCmsComponent regist-left-content-component reorder-containers"
            style="order: 1;"
          >
            <div
              class="banner__component simple-banner"
              style="width: 100%; height: auto;"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
